/**
 * Collects the connector setup values a connector mutation depends on, so the
 * setup fingerprint changes whenever re-applying would produce something else.
 */

import { PIPEEX_UI_CONNECTOR_FIELD_IDS } from '../../../api/pipeex/pipeexWizardProfileState';
import { getFormFieldValue } from './formFieldValues';
import type { ConnectorBindingConfiguration } from '../../../types/config/connector.types';

export const collectConnectorSetupFields = (
  configuration: ConnectorBindingConfiguration
): Record<string, string | null> => {
  const fields: Record<string, string | null> = {};

  for (const fieldId of PIPEEX_UI_CONNECTOR_FIELD_IDS) {
    fields[fieldId] = getFormFieldValue(configuration[fieldId]);
  }

  return fields;
};
